import removeExtensionFromPath from '@utility/helpers/removeExtensionFromPath';
import { openDB } from 'idb';

export const initDB = async (dbName: string) => {
  return openDB(dbName, 20, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('lists')) {
        const listsStore = db.createObjectStore('lists', {
          keyPath: 'id',
          autoIncrement: true,
        });
        listsStore.createIndex('name', 'name', { unique: false });
      }
      if (!db.objectStoreNames.contains('likes')) {
        const likesStore = db.createObjectStore('likes', {
          keyPath: 'id',
          autoIncrement: true,
        });
        likesStore.createIndex('name', 'name', { unique: false });
      }
    },
  });
};

// Rest of your functions remain the same, but use the common initDB function
export const addItem = async (item: any, dbName: string, storeName: string) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  const id = await store.add(item);
  await tx.done;
  return id;
};

export const getItem = async (dbName: string, storeName: string) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readonly');
  const store = tx.objectStore(storeName);
  const items = await store.getAll();
  await tx.done;
  return items;
};

export const getObjectByName = async (
  name: string,
  dbName: string,
  storeName: string,
) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readonly');
  const store = tx.objectStore(storeName);
  const index = store.index('name');
  const result = await index.get(name);
  await tx.done;
  return result;
};

export const updateItem = async (
  item: any,
  dbName: string,
  storeName: string,
) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  await store.put(item);
  await tx.done;
};

export const removeItem = async (
  item: any,
  dbName: string,
  storeName: string,
) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  await store.delete(item);
  await tx.done;
};

export const deleteItemByEntityId = async (
  entityId: string,
  dbName: string,
  storeName: string,
) => {
  const db = await initDB(dbName);
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);

  const allItems = await store.getAll();
  for (const item of allItems) {
    if (
      (item.entity && removeExtensionFromPath(item.entity.id) === entityId) ||
      item.entity.data?.linkUrl === entityId ||
      item.entity.fields?.linkUrl === entityId
    ) {
      await store.delete(item.id);
      break;
    }
  }

  await tx.done;
};
